module.exports = __webpack_public_path__ + "img/za@2x.30aec879.png";